var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import colors from '../colors';
import { sizeMap } from './common';
export var PlaybookAlert = forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? colors.grey[900] : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.title, title = _c === void 0 ? '' : _c;
    var size = sizeMap[variant];
    return (_jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: [_jsx("title", { children: title }), _jsx("path", { d: "M9.84079 13.8457L10.3326 9.97298M6.21585 13.8449L7.05484 7.564C7.19759 6.49529 8.10932 5.69726 9.18752 5.69726H14.8509C15.934 5.69726 16.8483 6.50245 16.9853 7.57693L17.7839 13.8449M3.98358 7.25475L1.88794 7.25475M22.1118 7.22859L20.0161 7.22859M4.90155 4.1649L2.82309 2.9649M19.1164 4.14928L21.1949 2.94928M4.61426 17.2299H19.3841C19.7332 17.2299 20.0161 17.5129 20.0161 17.8619V20.4186C20.0161 20.7677 19.7332 21.0507 19.3841 21.0507H4.61426C4.2652 21.0507 3.98224 20.7677 3.98224 20.4186V17.8619C3.98224 17.5129 4.2652 17.2299 4.61426 17.2299Z", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
});
